var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subscription-form-container"
  }, [_c('div', {
    staticClass: "section-container"
  }, [_c('substrate-mount', [_c('div', {
    staticClass: "textarea-composite-container"
  }, [_c('input-textarea', {
    attrs: {
      "input-id": "bill-description",
      "input-name": _vm.$t('common.description'),
      "input-title": _vm.$t('enter.description'),
      "input-placeholder": _vm.$t('what.paid'),
      "max-length": 510,
      "required": false,
      "rows": 1,
      "composite": ""
    },
    model: {
      value: _vm.bill.description,
      callback: function callback($$v) {
        _vm.$set(_vm.bill, "description", $$v);
      },
      expression: "bill.description"
    }
  }), _c('attachment-image', {
    attrs: {
      "link": _vm.bill.attachment.link,
      "input-id": "bill.attachment",
      "type": "secondary",
      "composite": "",
      "composite-textarea": ""
    },
    on: {
      "loading": _vm.onImageLoading,
      "uploaded": function uploaded(data) {
        return _vm.bill.attachment.setData(data);
      },
      "reset": function reset($event) {
        return _vm.bill.attachment.reset();
      }
    }
  })], 1), _c('div', {
    staticClass: "switcher-container"
  }, [_c('cs-switcher', {
    attrs: {
      "label": _vm.$t('allow.multiple.payments')
    },
    model: {
      value: _vm.bill.isMulti,
      callback: function callback($$v) {
        _vm.$set(_vm.bill, "isMulti", $$v);
      },
      expression: "bill.isMulti"
    }
  })], 1), _c('div', {
    staticClass: "switcher-container"
  }, [_c('cs-switcher', {
    attrs: {
      "label": _vm.$t('variants.name')
    },
    model: {
      value: _vm.bill.useTariffName,
      callback: function callback($$v) {
        _vm.$set(_vm.bill, "useTariffName", $$v);
      },
      expression: "bill.useTariffName"
    }
  })], 1), _c('div', {
    staticClass: "switcher-container"
  }, [_c('cs-switcher', {
    attrs: {
      "label": _vm.$t('variants.description')
    },
    model: {
      value: _vm.bill.useTariffDescription,
      callback: function callback($$v) {
        _vm.$set(_vm.bill, "useTariffDescription", $$v);
      },
      expression: "bill.useTariffDescription"
    }
  })], 1), _vm.periodicRecurrentPaymentPermission ? _c('div', {
    staticClass: "switcher-container"
  }, [_c('cs-switcher', {
    attrs: {
      "label": _vm.$t('organize.subscription')
    },
    model: {
      value: _vm.bill.useSubscription,
      callback: function callback($$v) {
        _vm.$set(_vm.bill, "useSubscription", $$v);
      },
      expression: "bill.useSubscription"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "switcher-container"
  }, [_c('cs-switcher', {
    attrs: {
      "label": _vm.$t('organize.content.delivery')
    },
    model: {
      value: _vm.bill.isContentUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.bill, "isContentUrl", $$v);
      },
      expression: "bill.isContentUrl"
    }
  })], 1)])], 1), _vm._l(_vm.bill.billTariffs, function (tariff, idx) {
    return _c('div', {
      key: "tariff-".concat(idx),
      staticClass: "section-container"
    }, [_vm.isDesktop ? [_vm.isSeveralTariffsAvailable ? _c('form-movement-control', {
      attrs: {
        "inactive-up": _vm.isInactiveMovementUp(idx),
        "inactive-down": _vm.isInactiveMovementDown(idx)
      },
      on: {
        "movementUp": function movementUp($event) {
          return _vm.onMovementUp(idx);
        },
        "movementDown": function movementDown($event) {
          return _vm.onMovementDown(idx);
        }
      }
    }) : _vm._e(), _vm.isSeveralTariffsAvailable ? _c('form-delete-icon', {
      on: {
        "click": function click($event) {
          return _vm.onRemoveTariff(idx);
        }
      }
    }) : _vm._e()] : _vm._e(), _c('substrate-mount', [_vm.bill.useTariffName ? _c('div', {
      staticClass: "input-container"
    }, [_c('input-textarea', {
      attrs: {
        "input-id": "tariff-name-".concat(idx),
        "input-name": _vm.$t('common.name'),
        "input-title": _vm.$t('enter.title'),
        "input-placeholder": _vm.$t('for.example.base'),
        "max-length": 255,
        "required": false,
        "rows": 1
      },
      model: {
        value: tariff.name,
        callback: function callback($$v) {
          _vm.$set(tariff, "name", $$v);
        },
        expression: "tariff.name"
      }
    })], 1) : _vm._e(), _vm.bill.useTariffDescription ? _c('div', {
      staticClass: "input-container"
    }, [_c('input-textarea', {
      attrs: {
        "input-id": "tariff-description-".concat(idx),
        "input-name": _vm.$t('common.description'),
        "input-title": _vm.$t('enter.description'),
        "input-placeholder": _vm.$t('what.tariff.give'),
        "max-length": 255,
        "required": false,
        "rows": 1
      },
      model: {
        value: tariff.description,
        callback: function callback($$v) {
          _vm.$set(tariff, "description", $$v);
        },
        expression: "tariff.description"
      }
    })], 1) : _vm._e(), _c('labeled-input', {
      attrs: {
        "label": _vm.$t('amount.for.pay', {
          getCurrencySign: _vm.currency.sign
        }),
        "placeholder": "0 ".concat(_vm.currency.sign),
        "error": _vm.$v.bill.billTariffs.$each[idx].amount.$error,
        "force-replace": [[/[^0-9\.\,]+/g, ''], [/^\./g, ''], [/\,/, '\.']],
        "force-format": [_vm.$formatInputAmount({
          significantZeros: _vm.currency.significant_zeros,
          decimalsSeparator: '.',
          thousandSeparator: ' '
        })]
      },
      on: {
        "focus": _vm.$v.bill.billTariffs.$each[idx].amount.$reset,
        "blur": _vm.$v.bill.billTariffs.$each[idx].amount.$touch
      },
      model: {
        value: tariff.amount,
        callback: function callback($$v) {
          _vm.$set(tariff, "amount", $$v);
        },
        expression: "tariff.amount"
      }
    }), _vm.bill.useSubscription ? [_c('div', {
      staticClass: "option-container",
      on: {
        "click": function click($event) {
          return _vm.onShownWriteOffOptions(tariff.writeOffOption, idx);
        }
      }
    }, [_c('option-panel', {
      attrs: {
        "option": _vm.getPreparedWriteOffOption(tariff.writeOffOption),
        "noactive": ""
      }
    }, [_c('cs-button', {
      attrs: {
        "type": "secondary"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('common.change')) + " ")])], 1)], 1), _c('div', {
      staticClass: "switcher-container"
    }, [_c('cs-switcher', {
      attrs: {
        "label": _vm.$t('allow.payment.without.subscription')
      },
      model: {
        value: tariff.oneTimePayment,
        callback: function callback($$v) {
          _vm.$set(tariff, "oneTimePayment", $$v);
        },
        expression: "tariff.oneTimePayment"
      }
    })], 1), _vm.isShownTrialDaysSwitcher(tariff) ? [_c('div', {
      staticClass: "switcher-container"
    }, [_c('cs-switcher', {
      attrs: {
        "label": _vm.$t('subscription.form.trial.days.swicther.label')
      },
      model: {
        value: tariff.useTrialDays,
        callback: function callback($$v) {
          _vm.$set(tariff, "useTrialDays", $$v);
        },
        expression: "tariff.useTrialDays"
      }
    })], 1), tariff.useTrialDays ? _c('div', {
      staticClass: "input-container"
    }, [_c('input-number', {
      attrs: {
        "input-name": _vm.$t('subscription.form.trial.days.input.label'),
        "input-title": _vm.$t('subscription.form.trial.days.input.label'),
        "input-placeholder": "0",
        "input-id": "tariff-trial-days-".concat(idx),
        "show-counter": false,
        "min-value": 1,
        "max-value": 365,
        "required": false
      },
      model: {
        value: tariff.trialDays,
        callback: function callback($$v) {
          _vm.$set(tariff, "trialDays", $$v);
        },
        expression: "tariff.trialDays"
      }
    }, [_c('help-link', {
      attrs: {
        "slot": "link",
        "source": "https://help.capusta.space/bill/trial_subscription"
      },
      slot: "link"
    })], 1)], 1) : _vm._e()] : _vm._e()] : _vm._e(), _vm.bill.isContentUrl ? _c('div', {
      staticClass: "input-container"
    }, [_c('input-link-or-iframe', {
      ref: "tariffContentUrl",
      refInFor: true,
      attrs: {
        "input-id": "tariff-content-url-".concat(idx),
        "input-name": _vm.$t('link.to.content.or.code.for.embedding'),
        "input-placeholder": "https://mysite.ru/myfile.pdf",
        "capusta-info": "billIframe"
      },
      on: {
        "showInfo": function showInfo($event) {
          return _vm.$emit('showInfo');
        }
      },
      model: {
        value: tariff.contentUrl,
        callback: function callback($$v) {
          _vm.$set(tariff, "contentUrl", $$v);
        },
        expression: "tariff.contentUrl"
      }
    })], 1) : _vm._e(), !_vm.isDesktop ? [_vm.isSeveralTariffsAvailable ? _c('div', {
      staticClass: "controls-container"
    }, [_c('form-movement-control', {
      attrs: {
        "inactive-up": _vm.isInactiveMovementUp(idx),
        "inactive-down": _vm.isInactiveMovementDown(idx)
      },
      on: {
        "movementUp": function movementUp($event) {
          return _vm.onMovementUp(idx);
        },
        "movementDown": function movementDown($event) {
          return _vm.onMovementDown(idx);
        }
      }
    }), _c('form-delete-icon', {
      on: {
        "click": function click($event) {
          return _vm.onRemoveTariff(idx);
        }
      }
    })], 1) : _vm._e()] : _vm._e()], 2)], 2);
  }), !_vm.isExceededTariffsCount ? _c('div', {
    staticClass: "panel-container"
  }, [_c('capusta-panel', {
    attrs: {
      "icon": "circle-plus",
      "description": _vm.$t('add.variant')
    },
    on: {
      "click": _vm.onAddTariff
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "button-primary-container"
  }, [_c('cs-button', {
    attrs: {
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('get.link')) + " ")])], 1), _c('div', {
    staticClass: "button-secondary-container"
  }, [_c('cs-button', {
    attrs: {
      "type": "secondary",
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.onSubmitWithQrCode
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('cs-icon', {
    attrs: {
      "name": "qr-code",
      "size": "extra-medium"
    }
  })], 1), _vm._v(" " + _vm._s(_vm.$t('get.qr')) + " ")])], 1), _c('reusable-dialog', {
    model: {
      value: _vm.isShownWriteOffOptions,
      callback: function callback($$v) {
        _vm.isShownWriteOffOptions = $$v;
      },
      expression: "isShownWriteOffOptions"
    }
  }, _vm._l(_vm.getPreparedWriteOffOptions, function (option) {
    return _c('div', {
      key: option.id,
      class: _vm.$style.periodicity
    }, [_c('option-panel', {
      attrs: {
        "option": option
      },
      on: {
        "click": _vm.onSelectWriteOffOption
      }
    })], 1);
  }), 0)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }